import {
  type FC, useEffect,
  useState,
} from 'react';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  useActiveBoundaryTerritoryGroupsSelector, useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector,
  useBoundaryTerritoryGroupsIsLoadingSelector,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { type ModalProps } from '../../../../../modal/modalType.enum';
import { CustomizeBoundaryFillsComponent } from './customizeBoundaryFills.component';

export type CustomizeBoundaryFillsContainerProps = ModalProps<{
  boundaryGroupId: number;
}>;

export const CustomizeBoundaryFillsContainer: FC<CustomizeBoundaryFillsContainerProps> = ({
  boundaryGroupId,
  onClose,
  isOpen,
}) => {
  const [t] = useTranslation();
  const boundaryTerritoryGroups = useBoundaryTerritoryGroupsGroupedByBoundaryGroupSelector()
    .find(item => item.boundaryGroupId === boundaryGroupId)?.boundaryTerritoryGroups;
  const activeBoundaryTerritoryGroups = useActiveBoundaryTerritoryGroupsSelector();
  const isLoadingBTGs = useBoundaryTerritoryGroupsIsLoadingSelector();
  const [isLoadingFillChanges, setIsLoadingFillChanges] = useState(false);
  const activeBTGId = activeBoundaryTerritoryGroups.find(item => item.boundaryGroupId === boundaryGroupId)?.boundaryTerritoryGroupId;

  useEffect(() => {
    if (!boundaryTerritoryGroups) {
      onClose();
    }
  }, [boundaryTerritoryGroups, onClose]);

  if (!boundaryTerritoryGroups) {
    return null;
  }

  return (
    <CustomizeBoundaryFillsComponent
      boundaryTerritoryGroups={boundaryTerritoryGroups}
      activeBoundaryTerritoryGroupId={activeBTGId}
      title={t('Fill Settings')}
      onClose={onClose}
      isOpen={isOpen}
      showLoading={isLoadingBTGs || isLoadingFillChanges}
      onIsLoadingChange={setIsLoadingFillChanges}
    />
  );
};
